<template>
  <v-content>
    <v-container>
      <v-row
        align="center"
        justify="center"
        class="my-0"
      >
        <v-col
          cols="12"
          sm="12"
        >
          <figure class="d-flex align-center md4">
            <img
              class="mx-auto align-center"
              :src="retornarParametrosGenerales && retornarParametrosGenerales.urlLgo ? retornarParametrosGenerales.urlLgo : '../../../../img/logo.png'"
              :alt="$t('logo_alt')"
            >
          </figure>
        </v-col>
      </v-row>
    </v-container>
    <v-app-bar
      class="py-0 d-flex justify-center"
      color="primary"
      dark
    >
      <div class="overflow-hidden">
        <v-bottom-navigation
          v-model="botonActivar"
          color="white"
          background-color="py-0 primary"
          dark
        >
          <v-btn
            href="http://www.vid.org.co/"
            active-class="secondary"
            class="body-1"
            value="Regresar"
          >
            <span class="white--text">
              {{ $t('menu.regresar') }}
            </span>
          </v-btn>
          <span class="my-auto separador" />
          <v-btn
            :to="{ name: 'PagosEnLinea' }"
            active-class="secondary"
            class="body-1"
            value="Pagos en línea"
          >
            <span class="white--text">{{ $t('menu.pagos_en_linea') }}</span>
          </v-btn>
          <span class="my-auto separador" />
          <v-btn
            :to="{ name: 'Donaciones' }"
            active-class="secondary"
            class="body-1"
            value="Dona aquí"
          >
            <span class="white--text">{{ $t('menu.dona_aqui') }}</span>
          </v-btn>
        </v-bottom-navigation>
      </div>
    </v-app-bar>
  </v-content>
</template>

<script>
import { mapGetters } from 'vuex'
/**
 * Component that represent the application menu bar.
 *
 * @author C Camilo Castellanos
 * @version 1.0.0
 * @since 20/12/2019 1:01 a. m.
 */
export default {
  name: 'AppPublicMenu',
  data () {
    return {
      botonActivar: ''
    }
  },
  computed: {
    ...mapGetters([
      'retornarParametrosGenerales'
    ])
  }
}
</script>

<style lang="scss" scoped>
  .button {
    &--color {
      color: #ffffff !important;
    }
  }
  .button:not(.v-btn--active) {
    color: #ffffff !important;
  }
  .separador {
    height: 1.5em;
    border-width: 1px;
    border-right-style: solid;
    border-right-color: #ffffff;
  }
</style>
<i18n>
{
  "es": {
    "logo_alt": "Imagen Banner",
    "menu": {
      "regresar":"Regresar",
      "pagos_en_linea":"Pagos en línea",
      "dona_aqui":"Dona aquí"
    }
  }
}
</i18n>
